import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"

export default function Topsellernew() {
  // 配置默认排序
  const defaultSort = {

  }

  return (
    <>
      <Head>
        <title>{`Top Sellers of the Week | Best Sales Champions | Bestdeals.co.nz`}</title>
        <meta name="keywords" content={`best deals nz, best deals, bestdeals nz, bestdeals`}></meta>
        <meta name="description" content={`Discover this week's top-selling products at Bestdeals.co.nz! Browse the sales champion ranking edition to find customer favorites and shop the latest trends now.`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout >
        <FeaturedSection type="top-seller" defaultSort={defaultSort} />
      </DefaultLayout>
    </>

  )
}